"use client"
export const dynamic = 'force-dynamic';
import Link from "next/link";
import React, {useState} from "react";

export default function Home() {

  const [passwordVisible, setPasswordVisible] = useState<boolean>(false);

  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");



  const signIn = async () => {


    try {
      const response = await fetch("/api/login", {
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({
          email, password
        })
      });

      const json_res = await response.json();

      if (response.status === 200) {
        // if (json_res.position === "staff") {
        //   window.location.href = "/admin/mytasks"
        // } else if (json_res.position === "manager") {
        //   window.location.href = "/admin/managetasks"
        // } else if (json_res.position === "admin") {
        //   window.location.href = "/admin/manageteam"
        // }
        window.location.href = "/admin";
      } else {
        alert(json_res.message);
      }
    } catch (err) {
      console.log(err);
      alert("Network Connectivity Issues.");
    }

  }



  return (
    <main className="loginmain">
      
      <div className="loginmain-leftimg"></div>

      <div className="loginmain-rightinputs">

        <img src="/logo.png" className="signinlogo" alt="" />

        <p className="large signinheader bold">Sign In</p>

        <input type="email" className="textinput logininput" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-Mail"/>

        
        <div className="passwordinput-container logininput">
          <input type={!passwordVisible ? "password": "text"} className="textinput passwordinput" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password"/>
          <p className="passwordinput-viewpassword" onClick={() => setPasswordVisible(!passwordVisible)}>
            {passwordVisible ? <i className="fa-regular fa-eye-slash"></i> : <i className="fa-regular fa-eye"></i>}
          </p>
        </div>
        

        
        <button className="orangebutton loginbutton" onClick={signIn}>Sign In</button>

        <Link href="/recoverpassword" style={{textDecoration: "none"}}><p className="small blue plink" style={{marginTop: "44px"}} title="Recover Password">Recover Password</p></Link>
      </div>

    </main>
  );
}
